<template>
  <div class="companyDetail sirui-search">
    <!--公司信息-->
    <el-form ref="companyDetail" label-position="right" label-width="80px" :model="detail">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyCode')">
            <el-input v-model="detail.createCompanyCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyStatus')">
            <el-input v-model="detail.currentStatusName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyName')">
            <el-input v-model="detail.createCompanyName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyAddress')">
            <el-input v-model="detail.companyAddress" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyNational')">
            <!-- <el-input v-model="detail.companyNationalName" disabled></el-input> -->
            <el-select
              class="inputWidth"
              filterable
              v-model="detail.companyNational"
              :placeholder="''"
              clearable
              disabled
            >
              <el-option
                style="width: 100%"
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="propClass" :label="$t('company.detail.creditCode')">
            <el-input v-model="detail.creditCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyIndex')">
            <el-input-number
              v-model="detail.sortOrder"
              :controls="false"
              class="inputWidth"
              :min="0"
              :max="999"
              disabled
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="department-content">{{ this.$t('company.departmentTitle') }}</div>
    <sirui-table
      ref="siruiTable"
      :buttonList="[]"
      :loading="false"
      :data="tableData"
      :paging="false"
      :setting="false"
      :reserve="false"
    >
      <vxe-table-column type="seq" :title="$t('table.index')" width="60"></vxe-table-column>
      <!-- <vxe-table-column
        v-for="(item,index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      ></vxe-table-column> -->
      <vxe-table-column
        field="createDepartmentName"
        :title="$t('company.table.departmentName')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            style="width: 100%"
            clearable
            v-model="scope.row.createDepartmentName"
            :placeholder="$t('company.departmentPlaceholder')"
            @change="$refs.xTable.updateStatus(scope)"
          ></el-input>
        </template>
        <template v-slot="{ row }">{{ row.createDepartmentName }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="receiptClaimMode"
        :title="$t('company.detail.receiptClaimMode')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.receiptClaimMode, receiptClaimModeList) + ''"
            placement="bottom"
            :disabled="
              scope.row.receiptClaimMode == '' || scope.row.receiptClaimMode == null ? true : false
            "
          >
            <el-select
              style="width: 100%"
              v-model="scope.row.receiptClaimMode"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                style="width: 100%"
                v-for="item in receiptClaimModeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{
          getSelectLabel(row.receiptClaimMode, receiptClaimModeList)
        }}</template>
      </vxe-table-column>
    </sirui-table>
  </div>
</template>
<script>
  // import API from '@/api/masterData/company.js';
  import SiruiTable from '@/components/SiruiTable';
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';
  export default {
    name: 'companyDetail',
    components: {
      SiruiTable,
    },
    data() {
      return {};
    },
    props: {
      detail: {
        type: Object,
        default: () => {},
      },
      flag: {
        type: Boolean,
        default: () => true,
      },
      tableData: {
        type: Array,
        default: () => [],
      },
      receiptClaimModeList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        //获取定价规则值
        country(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'person_national').dictList;
          }
        },
      }),
      columnList() {
        return [
          {
            prop: 'companyDepartmentName',
            label: this.$t('company.table.departmentName'),
          },
        ];
      },
    },
    methods: {
      //表格组件下拉框选择回调
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
